import { cn } from '@/utils/uiUtils';

type GarminAttributionProps = {
  deviceModel?: string | null;
  label?: string;
  className?: string;
};

export function GarminAttribution({
  deviceModel,
  label,
  className,
}: GarminAttributionProps) {
  const displayLabel =
    label ?? (deviceModel ? `Garmin ${deviceModel}` : 'Garmin');

  return (
    <div
      className={cn(
        'text-[10px] font-semibold uppercase tracking-[0.24em] text-gray-500 dark:text-gray-400',
        className
      )}
    >
      {displayLabel}
    </div>
  );
}
